<template>
	<Col class="height-100 width-100">
		<AnalyticsTable :tableData="tableData" :customColumns="customColumns" />
	</Col>
</template>
<script>
import AnalyticsMixin from '@/components/Analytics/mixins/AnalyticsMixin.js';
import AnalyticsTable from '@/components/Analytics/Table/AnalyticsTable.vue';
export default {
	name: 'AnalyticsByDays',
	mixins: [AnalyticsMixin],
	components: { AnalyticsTable },
	computed: {
		customColumns() {
			return [{ key: 'date', title: 'Date' }];
		},
		tableData() {
			return this.populateTableDataWithCalculatedColumns(this.runsByDayArr);
		},
	},
};
</script>
<style scoped lang="scss"></style>
